import type { RouteRecordRaw } from 'vue-router'

// Email actions must remain reachable even when another account is signed in.
export const authLinkRoutes: RouteRecordRaw[] = [
  {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('../views/PasswordResetView.vue'),
  },
  {
    path: '/password-reset/confirm/:token',
    name: 'password-reset-confirm',
    component: () => import('../views/PasswordResetConfirmView.vue'),
  },
  {
    path: '/nickname-change/:token',
    name: 'nickname-change',
    component: () => import('../views/NicknameChangeView.vue'),
  },
  {
    path: '/forgot-username',
    name: 'forgot-username',
    component: () => import('../views/ForgotUsernameView.vue'),
  },
  {
    path: '/activate/:token',
    name: 'activate',
    component: () => import('../views/ActivationView.vue'),
  },
]
